<template>

<div>
	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page-heading -->
		<page-heading :show="true" pageTitle="CONTENT_POOL-SETTINGS"></page-heading>

		<div class="columns">

			<div class="col-main">
					<pre>
						{{ options }}
					</pre>
			</div>

			<div class="col-aside">

			</div>

		</div>

	</template>

</div>

</template>


<script>

export default {

    name: "settings",

	data() {

		return {
			isLoading: false,
			selectedId: null,
			options: [],
		}
	},

	created() {

        this.fetchData();

	},

	mounted() {


	},

	methods: {

		fetchData() {

			var self = this;
			self.isLoading = true;


			function getCatalogs() {
				return self.axios.get(self.$config.api + 'catalog');
			}

			function getSettings() {
				return self.axios.get(self.$config.api + 'setting?filters[name]=SitePerformanceDocument.catalog');
			}

			// make the request
			this.axios.all([getCatalogs(), getSettings()])
				.then(self.axios.spread(function (getCatalogs, getSetting) {
                	self.options = getCatalogs.data.catalog;
					self.selectedId = getSetting.data.setting[0];
					self.isLoading = false;
				}));

		},

	}
}
</script>
